module.exports = __webpack_public_path__ + "img/sxgl2.1dee9455.png";